/**
 * Who a referred document goes to when the approval policy names nobody usable.
 *
 * Each value names the first step; every chain then continues with the optional fallback user.
 * When no step names anybody, the document waits with nobody assigned.
 */
export const ApproverFallbackStrategy = {
  /** No automatic step at all: a person names the approver on the document. */
  MANUAL_APPROVER_SELECTION: 'MANUAL_APPROVER_SELECTION',
  /** Everybody in the account who may approve this kind of document, as one group. */
  ANYONE_WITH_PERMISSION: 'ANYONE_WITH_PERMISSION',
  /** Head of the owner's unit and upwards. */
  ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION:
    'ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION',
  /** The named user — required under this chain. */
  FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION: 'FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION',
  /** Head of the chosen unit and upwards. */
  ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION: 'ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION',
  /** Head of the document's own unit and upwards. */
  DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION:
    'DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION',
  /** Everybody in the chosen unit, as one group. */
  ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION: 'ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION',
  /** Everybody holding the chosen role, as one group. */
  ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION: 'ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION',
  /** The approver the document itself names. */
  SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION: 'SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION'
} as const;

export type ApproverFallbackStrategy =
  (typeof ApproverFallbackStrategy)[keyof typeof ApproverFallbackStrategy];
